<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>format_list_bulleted</mat-icon>
        <div>Categorias</div>
      </div>

      <div flex justify-content='flex-end' fxLayoutAlign="end">
        <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro'
          autocomplete="off">
        <a mat-button (click)="openDialog(null)" style='width:60px;'>
          <mat-icon color='primary'>add_circle_outline</mat-icon>
        </a>
      </div>

    </mat-toolbar>
  </mat-card>

  <mat-card id='table-body'>
    <!-- TABLE -->

    <mat-table [dataSource]="dataSource" matSort matSortActive="year" matSortDirection='desc' matSortDisableClear=true>

      <!-- Icon Column -->
      <ng-container matColumnDef="icon" class='mural-name'>
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon style='font-size:1.2em; margin-top:10px;'>format_list_bulleted</mat-icon>
        </mat-cell>
      </ng-container>

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Categoria </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name }}
        </mat-cell>
      </ng-container>

      <!-- Documentos Column -->
      <ng-container matColumnDef="documents">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Documentos </mat-header-cell>
        <mat-cell *matCellDef="let element">
        {{ element.documents | slice:0:33 }}
        <span *ngIf="element.documents.length > 50">...</span>
        </mat-cell>
      </ng-container>


      <!-- Documentos Column -->
      <ng-container matColumnDef="docList">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Docs </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div *ngIf="element.docList">
            <img src='/assets/images/status/img_green.png'>
          </div>
          <div *ngIf="!element.docList">
            <img src='/assets/images/status/img_silver.png'>
          </div>
        </mat-cell>
      </ng-container>

      <!-- partner Column -->
      <ng-container matColumnDef="partner">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Sócio </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span *ngIf='element.partner'>
            <img src='/assets/images/status/img_green.png'>
          </span>

          <span *ngIf='!element.partner'>
            <img src='/assets/images/status/img_silver.png'>
          </span>

        </mat-cell>
      </ng-container>

      <!-- hidden Column -->
      <ng-container matColumnDef="hidden">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Oculto </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <span *ngIf='element.hidden'>
            <img src='/assets/images/status/img_green.png'>
          </span>

          <span *ngIf='!element.hidden'>
            <img src='/assets/images/status/img_silver.png'>
          </span>

        </mat-cell>
      </ng-container>

      <!-- front_desk Column -->
      <ng-container matColumnDef="front_desk">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Loja </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <span *ngIf='element.front_desk'>
            <img src='/assets/images/status/img_green.png'>
          </span>

          <span *ngIf='!element.front_desk'>
            <img src='/assets/images/status/img_silver.png'>
          </span>

        </mat-cell>
      </ng-container>


      <!-- sponsor Column -->
      <ng-container matColumnDef="sponsor">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Patroc </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <span *ngIf='element.sponsor'>
            <img src='/assets/images/status/img_green.png'>
          </span>

          <span *ngIf='!element.sponsor'>
            <img src='/assets/images/status/img_silver.png'>
          </span>

        </mat-cell>
      </ng-container>

      <!-- annuity Column -->
      <ng-container matColumnDef="annuity">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Anuidade </mat-header-cell>
        <mat-cell *matCellDef="let element">

          <span *ngIf='element.annuity'>
            <img src='/assets/images/status/img_green.png'>
          </span>

          <span *ngIf='!element.annuity'>
            <img src='/assets/images/status/img_silver.png'>
          </span>

        </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info' style='font-size:1.5em;'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>


      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    <!-- END TABLE -->

  </mat-card>

  <mat-paginator [pageSizeOptions]="[9, 13, 26, 50]"></mat-paginator>

</div>